import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Stack, Typography, Button} from 'views/components';
import {WarningAmber} from 'views/icons';
import {DatePicker, Translate, translate} from 'views/module';

import moment from 'moment';

const RemoveRecurrence = (props) => {
  const onClose = props.onClose;
  const event = props.event;
  const recurrenceRn = props.recurrenceRn;
  const deleteRecurrence = props.deleteRecurrence;

  const [deleteAfterDate, setDeleteAfterDate] = React.useState(moment());

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression="client.ClientDetail.Scheduling.DeleteRecurrence" />
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1} >
          <Stack>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Title'/>
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {event.info.title}
            </Typography>
          </Stack>
          <Stack>
            <DatePicker
              label={translate('client.ClientDetail.Scheduling.DeleteAfterDate')}
              value={deleteAfterDate}
              onChange={setDeleteAfterDate}
              textFieldProps={{
                fullWidth: true,
                helperText: translate('client.ClientDetail.Scheduling.DeleteAfterDateHelper'),
                InputLabelProps: {shrink: true},
              }}
            />
          </Stack>
          <Stack
            direction='row'
            spacing={1}
            sx={{
              backgroundColor: 'grey.200',
              borderRadius: '8px',
              color: 'error.main',
              p: 1,
              py: 2,
            }}
          >
            <WarningAmber/>
            <Translate
              expression='generic.DeleteConfirm'
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={!deleteAfterDate?.isValid?.()}
          onClick={() => deleteRecurrence(recurrenceRn, '', deleteAfterDate)}
        >
          <Translate expression='generic.Delete' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RemoveRecurrence.propTypes = {
  recurrenceRn: PropTypes.string.isRequired,
  event: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  deleteRecurrence: PropTypes.func.isRequired,
};

export default React.memo(RemoveRecurrence);
